import ChangeStatusModal from './ChangeStatusModal.container'

export default ChangeStatusModal
